import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ColumnConfig } from '../../../models/column.model';
import { TableSorts } from '../../../models/table.model';

export class SortByField {
  column: ColumnConfig;
  sortOrder: 'asc' | 'desc';
}

@Component({
  selector: 'table-header-cell',
  templateUrl: './header-cell.component.html',
  styleUrls: ['./header-cell.component.scss'],
})
export class HeaderCellComponent implements OnInit {
  @Input() column: ColumnConfig;
  @Input() sorts: TableSorts;
  @Input() stackedIcons: boolean;
  @Input() dataExists: boolean;

  @Output() headerButtonClicked: EventEmitter<Event> =
    new EventEmitter<Event>();
  @Output() onSortByField: EventEmitter<SortByField> =
    new EventEmitter<SortByField>();

  public sortOrder: 'asc' | 'desc';

  ngOnInit(): void {
    this.sortOrder =
      this.sorts?.[this.column?.sortByProp] || this.sorts?.[this.column?.prop];
  }

  public onClick(event: Event) {
    event.stopPropagation();
    event.preventDefault();

    if (this.column.sortable) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      const { column, sortOrder } = this;

      this.onSortByField.emit({ column, sortOrder });
    }
  }

  public handleHeaderIconClick(event: Event) {
    this.headerButtonClicked.emit(event);
  }

  public iconSortActive(target: string): boolean {
    if (!this.sorts) return;

    const { sortByProp, prop } = this.column;

    if (this.sorts[sortByProp] || this.sorts[prop]) {
      return this.sortOrder === target;
    }
  }
}
